import { blue } from "@mui/material/colors";

export const themes = {
  default: {
    fontFamily: "assistant",
    image:"https://res.cloudinary.com/dlhfcdscf/image/upload/v1728244883/background_qcyhzb.jpg",
    textColor: "black",
    background: "#343131",
    clockTextColor: "white",
    buttonColor: "#334455",
    topRowBackground: "black",
    staticShabatImage:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734345681/public/shabatShalom_zu6u8b.jpg",
    message: {
      titleBackground: "#1A1A1A",
      messageBackground: "rgba(255, 255, 255, 0.8)",
      neonBackground: "#000000",
      neonText: "white",
      neonColor1: "#D4AF37",
      neonColor2: "#F5E6CC",
      birthdayColor1: "#D4AF37",
      birthdayColor2: "#F5E6CC",
      textColor: "#FFFFFF",
      margin: "100px",
    },
    shabbat: {
      // background: "rgba(5, 16, 19, 0.5)",
      borderColor: "white",
      textColor: "white",
      titleColor: "white",
      parashaColor: "white",
      fontFamily: "'assistant",
      image:"https://res.cloudinary.com/dlhfcdscf/image/upload/v1783938021/public/268d099c-496f-4b34-ad14-a73370115e51_bq4rja.jpg",
      // image:"https://res.cloudinary.com/dlhfcdscf/image/upload/v1783938021/public/268d099c-496f-4b34-ad14-a73370115e51_bq4rja.jpg",
      blurEffect: true,
    },
    newsBackground: "#ffffff",
    newsTextColor: "#334455",
    weatherTextColor: "white",
    rss: {
      background: "black",
      textColor: "white",
    },
  },
  pink: {
    fontFamily: "Assistant",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1728933145/Leonardo_Phoenix_A_serene_and_breathtaking_digital_artwork_dep_3_n4vkpi.jpg",
    topRowBackground: "white",
    textColor: "#F72C5B",
    clockTextColor: "#F72C5B",
    background: "#ffcccc",
    buttonColor: "#ff007f",
    staticShabatImage:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734345681/public/shabatShalom_zu6u8b.jpg",
    message: {
      titleBackground: "#CB9DF0",
      neonBackground: "white",
      neonText: "#550000",
      neonColor1: "#ff007f",
      neonColor2: "#ffcccc",
      birthdayColor1: "#ff007f",
      
      birthdayColor2: "#ffcccc",
      messageBackground: "rgba(255, 192, 203, 0.5)",
    },
    shabbat: {
      background: "#ECEBDE",
      borderColor: "pink",
      textColor: "white",
      titleColor: "white",
      parashaColor: "#D4AF37",
      fontFamily: "'Comic Sans MS', cursive",
      image:
        "https://res.cloudinary.com/dlhfcdscf/image/upload/v1783938021/public/268d099c-496f-4b34-ad14-a73370115e51_bq4rja.jpg",
    },
    newsBackground: "#fff0f0",
    newsTextColor: "#330000",
    rss: {
      background:
        "linear-gradient(to bottom, rgba(75, 89, 69, 0) 0%, rgba(255, 255, 255, 1) 100%, rgba(75, 89, 69, 0) 100%)",
      textColor: "black",
    },
  },
  green: {
    fontFamily: "assistant",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1733774868/Leonardo_Phoenix_A_serene_and_mystical_dense_forest_with_tower_0_it6sib.jpg",
    textColor: "black",
    topRowBackground: "rgba(75, 89, 69, 0.7)",
    clockTextColor: "white",
    background: "#ffcccc",
    buttonColor: "#ff007f",
    staticShabatImage:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734345681/public/shabatShalom_zu6u8b.jpg",
    message: {
      titleBackground: "#66785F",
      neonBackground: "white",
      neonText: "#550000",
      neonColor1: "#DDF6D2",
      neonColor2: "#DDF6D2",
      birthdayColor1: "#CAE8BD",
      birthdayColor2: "#537D5D",
      fontFamily: "assistant",
      messageBackground: "rgba(247, 247, 247, 0.5)",
    },
    shabbat: {
      background: "rgba(255, 255, 255, 0.1)",
      background: "#66785F",
      borderColor: "white",
      textColor: "white",
      titleColor: "white",
      parashaColor: "white",
      fontFamily: "'assistant",
      image:"https://res.cloudinary.com/dlhfcdscf/image/upload/v1783938021/public/268d099c-496f-4b34-ad14-a73370115e51_bq4rja.jpg",
      blurEffect: true,
    },
    newsBackground: "#fff0f0",
    newsTextColor: "#330000",
    rss: {
      background:
        "linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(75, 89, 69, 1) 50%, rgba(255, 255, 255, 0) 100%)",
      textColor: "white",
    },
  },
  red: {
    fontFamily: "assistant",
    image:"https://res.cloudinary.com/dlhfcdscf/image/upload/v1734873064/public/redAndWhite_z2qzmz.jpg",
    textColor: "white",
    background: 'red',
    clockTextColor: "#FFFFFF",
    buttonColor: "#8B0000",
    topRowBackground: "#c70003",
    staticShabatImage:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734345681/public/shabatShalom_zu6u8b.jpg",
    message: {
      titleBackground: "#B22222",
      messageBackground: "white",
      neonBackground: "#B22222",
      neonText: "#FFFFFF",
      neonColor1: "white",
      neonColor2: "white",
      birthdayColor1: "#FF6347",
      birthdayColor2: "#FFA07A",
      textColor: "#FFFFFF",
    },
    shabbat: {
      background: "#FA8072",
      borderColor: "white",
      textColor: "white",
      titleColor: "white",
      parashaColor: "white",
      fontFamily: "'assistant",
      image:
        "https://res.cloudinary.com/dlhfcdscf/image/upload/v1783938021/public/268d099c-496f-4b34-ad14-a73370115e51_bq4rja.jpg",
      blurEffect: true,
    },
    newsBackground: "#FFA07A",
    newsTextColor: "#8B0000",
    rss: {
      background: "#B22222",
      textColor: "white",
    },
  },
  macabi: {
    fontFamily: "assistant",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734947569/public/macabi_piyeyc.jpg",
    textColor: "white",
    background: "#011E41",
    clockTextColor: "#E7EB64",
    buttonColor: "#8B0000",
    topRowBackground: "#011E41",
    staticShabatImage:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734345681/public/shabatShalom_zu6u8b.jpg",
    message: {
      titleBackground: "#011E41",
      messageBackground: "#011E41",
      neonBackground: "#011E41",
      neonText: "#FFFFFF",
      neonColor1: "#E7EB64",
      neonColor2: "#E7EB64",
      birthdayColor1: "#FF6347",
      birthdayColor2: "#FFA07A",
      textColor: "#FFFFFF",
    },
    shabbat: {
      background: "#011E41",
      borderColor: "white",
      textColor: "#E7EB64",
      titleColor: "#E7EB64",
      parashaColor: "white",
      fontFamily: "'assistant",
      image:
        "https://res.cloudinary.com/dlhfcdscf/image/upload/v1783938021/public/268d099c-496f-4b34-ad14-a73370115e51_bq4rja.jpg",
      blurEffect: true,
    },
    newsBackground: "#FFA07A",
    newsTextColor: "#8B0000",
    rss: {
      background: "#011E41",
      textColor: "#E7EB64",
    },
  },
  beitar: {
    fontFamily: "assistant",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1728244883/background_qcyhzb.jpg",
    textColor: "white",
    background: "#000000",
    clockTextColor: "#E7EB64",
    buttonColor: "#8B0000",
    topRowBackground: "#000000",
    staticShabatImage:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734345681/public/shabatShalom_zu6u8b.jpg",
    message: {
      titleBackground: "black",
      messageBackground: "#000000",
      neonBackground: "#FFE04F",
      neonText: "black",
      neonColor1: "black",
      neonColor2: "white",
      birthdayColor1: "#FF6347",
      birthdayColor2: "#FFA07A",
      textColor: "#FFFFFF",
    },
    shabbat: {
      background: "rgba(5, 16, 19, 0.5)",
      borderColor: "white",
      textColor: "#E7EB64",
      titleColor: "#E7EB64",
      parashaColor: "white",
      fontFamily: "'assistant",
      image:
        "https://res.cloudinary.com/dlhfcdscf/image/upload/v1783938021/public/268d099c-496f-4b34-ad14-a73370115e51_bq4rja.jpg",
      blurEffect: true,
    },
    newsBackground: "#FFA07A",
    newsTextColor: "#8B0000",
    rss: {
      background: "#000000",
      textColor: "#E7EB64",
    },
  },  
    bio: {
    fontFamily: "assistant",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1738508852/public/sea_qvuoem.jpg",
    textColor: "white",
    background: "#000000",
    clockTextColor: "#fefefe",
    buttonColor: "#8B0000",
    topRowBackground: "#006f87",
    staticShabatImage:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734345681/public/shabatShalom_zu6u8b.jpg",
    message: {
      titleBackground: "#01579b",
      messageBackground: "rgba(233, 250, 243, 0.95)",
      neonBackground: "#578FCA",
      neonText: "white",
      neonColor1: "#578FCA",
      neonColor2: "white",
      birthdayColor1: "#FF6347",
      birthdayColor2: "#FFA07A",
      textColor: "#FFFFFF",
    },
    shabbat: {
      background: "rgba(0, 111, 135, 0.5)",
      // background: "#006f87",
      borderColor: "white",
      textColor: "white",
      titleColor: "white",
      parashaColor: "white",
      fontFamily: "'assistant",
      image:
        "https://res.cloudinary.com/dlhfcdscf/image/upload/v1783938021/public/268d099c-496f-4b34-ad14-a73370115e51_bq4rja.jpg",
      blurEffect: true,
    },
    newsBackground: "#FFA07A",
    newsTextColor: "#8B0000",
    rss: {
      background: "rgba(0, 111, 135, 0.7)",
      textColor: "#ffffff",
    },
  }, 
  ocean: {
    fontFamily: "assistant",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1741682653/public/irgun_awpj4e.jpg",
    textColor: "white",
    background: "#015D9C",
    clockTextColor: "##FFFFFF",
    buttonColor: "#8B0000",
    topRowBackground: "#015D9C",
    staticShabatImage:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734345681/public/shabatShalom_zu6u8b.jpg",
    message: {
      titleBackground: "#015D9C",
      messageBackground: "#FFFFFF",
      neonBackground: "#015D9C",
      neonText: "#FFFFFF",
      neonColor1: "##FFFFFF",
      neonColor2: "##FFFFFF",
      birthdayColor1: "#FF6347",
      birthdayColor2: "#FFA07A",
      textColor: "#FFFFFF",
    },
    shabbat: {
      background: "#FA8072",
      borderColor: "white",
      textColor: "white",
      titleColor: "white",
      parashaColor: "white",
      fontFamily: "'assistant",
      image:
        "https://res.cloudinary.com/dlhfcdscf/image/upload/v1783938021/public/268d099c-496f-4b34-ad14-a73370115e51_bq4rja.jpg",
      blurEffect: true,
    },
    newsBackground: "#FFA07A",
    newsTextColor: "#8B0000",
    rss: {
      background: "#015D9C",
      textColor: "white",
    },
  }, 
  irgun: {
    fontFamily: "assistant",
    image:"https://res.cloudinary.com/dlhfcdscf/image/upload/v1741692782/public/irgunGreen_sdnvc4.jpg",
    textColor: "white",
    background: "#626F47",
    clockTextColor: "##FFFFFF",
    buttonColor: "#8B0000",
    topRowBackground: "#626F47",
    staticShabatImage:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734345681/public/shabatShalom_zu6u8b.jpg",
    message: {
      titleBackground: "#626F47",
      messageBackground: "#cdd8a2",
      neonBackground: "#FFCF50",
      neonText: "#000000",
      neonColor1: "#FFFFFF",
      neonColor2: "#FFFFFF",
      birthdayColor1: "#A4B465",
      birthdayColor2: "#626F47",
      textColor: "#FFFFFF",
    },
    shabbat: {
      background: "#FA8072",
      borderColor: "white",
      textColor: "white",
      titleColor: "white",
      parashaColor: "white",
      fontFamily: "'assistant",
      image:
        "https://res.cloudinary.com/dlhfcdscf/image/upload/v1783938021/public/268d099c-496f-4b34-ad14-a73370115e51_bq4rja.jpg",
      blurEffect: true,
    },
    newsBackground: "#FFA07A",
    newsTextColor: "#8B0000",
    rss: {
      background: "#626F47",
      textColor: "white",
    },
  }, 
};
